module.exports = __webpack_public_path__ + "img/kakomon_banner_2024.20f07e08.jpg";